import { PaginatedResponse } from '../PaginatedResponse';

export interface ExternalProductMatching {
  productID?: number;
  productName?: string;
  optionValueID?: string;
  basePrice?: number;
  listPrice?: number;
  existingID?: string;
  externalID?: string;
  externalListPrice?: number;
}

export type ExternalProductMatchings =
  PaginatedResponse<ExternalProductMatching> & {
    matchingCount: number;
  };

const externalProductMatchingFromResponse = (
  responseData: any,
): ExternalProductMatching => ({
  productID: responseData.product_id,
  productName: responseData.product_name,
  optionValueID: responseData.option_value_id,
  basePrice: responseData.base_price,
  listPrice: responseData.list_price,
  existingID: responseData.existing_id,
  externalID: responseData.external_id,
  externalListPrice: responseData.external_list_price,
});

export const externalProductMatchingsFromResponse = (
  responseData: any,
): ExternalProductMatchings => ({
  data: (responseData.data ?? []).map(externalProductMatchingFromResponse),
  totalCount: responseData.total_count,
  matchingCount: responseData.matching_count,
});
